export default "<div class=\"view-container\">\r\n    <app-header></app-header>\r\n</div>\r\n"